import { Component } from '@angular/core';
import * as lookUpMasterDetails from '../assets/json/LookupMaster.json';
import { OnInit } from '@angular/core';
import { ApplicationConstant } from './application.constant';
import { AppStateService } from './shared/service/ui/app-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(private appStateService: AppStateService) {}

  public ngOnInit(): void {
    ApplicationConstant.lookMasterDetails = (lookUpMasterDetails as any).default;
    this.appStateService.initSessionTracker();
    this.appStateService.loadDeferredFile();
  }
}
